import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Container = styled.div`
  border-radius: 5px;
  border: 1px solid #dbdbdc;
`
const Header = styled.div`
  background: #dbdbdc;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
`
const Title = styled.div`
  font-weight: bold;
  font-size: 16px;
`
const Link = styled.a`
  color: #3f9ecc !important;
  &:hover {
    color: #3f9ecc;
    cursor: pointer;
  }
`

const Panel = ({ title, onClick, onClickText, id, className, children }) => {
  return (
    <Container id={id} className={className}>
      <Header>
        <Title>
          {title}
        </Title>
        {
          onClick && (
            <Link onClick={onClick}>
              {onClickText}
            </Link>
          )
        }
      </Header>
      <div>
        {children}
      </div>
    </Container>
  )
}

Panel.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  collapsible: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  onClickText: PropTypes.string,
  title: PropTypes.string.isRequired
}

export default Panel
